import { setUiLocale, useUiLocale } from './locale';
export function LanguageSwitcher() {
  const locale = useUiLocale();
  return (
    <select
      aria-label="Language / 语言"
      value={locale}
      onChange={(event) => setUiLocale(event.target.value === 'zh' ? 'zh' : 'en')}
      className="rounded-full border border-hairline bg-canvas-pure px-2 py-1 text-xs font-semibold text-ink focus-visible:ring-2 focus-visible:ring-brand-coral"
    >
      <option value="en">English</option>
      <option value="zh">中文</option>
    </select>
  );
}
